import React from 'react';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles({
	hintBadge: {
		position: 'absolute',
		top: 8,
		right: 12,
		zIndex: 10000,
		pointerEvents: 'none',
		padding: '2px 8px',
		borderRadius: 3,
		backgroundColor: 'rgba(0,0,0,0.6)',
		color: '#fff',
		fontFamily: 'sans-serif',
		fontSize: '0.75em',
		fontWeight: 600,
		letterSpacing: '0.02em',
	},
});


export const HintBadge = ({ children, className }) => {
	const classes = useStyles();
	const rootClass = className ? `${classes.hintBadge} ${className}` : classes.hintBadge;
	return <div className={rootClass}>{children}</div>;
}
